function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "60 70 80 90",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#000",
  strokeWidth: "2",
  d: "M60 100h80v20H60z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e6e6e6",
  stroke: "#000",
  strokeWidth: "2",
  d: "M60 120h80v20H60z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#d0d0d0",
  stroke: "#000",
  strokeWidth: "2",
  d: "M60 140h80v20H60z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M100 120V70",
  stroke: "#000",
  strokeWidth: "3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M80 90l20-20 20 20",
  fill: "none",
  stroke: "#000",
  strokeWidth: "3"
})));